import { cn } from '@/utils';

// Base font classes that can be reused
export const baseFontClass = 'font-sans antialiased';


export const TypographyH1 = ({ className, children }: React.ComponentProps<'h1'>) => {
  return (
    <h1
      className={cn(
        'text-primary scroll-m-20 text-6xl font-bold tracking-tight first:mt-0',
        baseFontClass,
        className,
      )}
    >
      {children}
    </h1>
  );
};

export const TypographyH2 = ({ className, children }: React.ComponentProps<'h2'>) => {
  return (
    <h2
      className={cn(
        'text-primary scroll-m-20 text-5xl font-bold tracking-tight first:mt-0',
        baseFontClass,
        className,
      )}
    >
      {children}
    </h2>
  );
};

export const TypographyH3 = ({ className, children }: React.ComponentProps<'h3'>) => {
  return (
    <h3
      className={cn(
        'text-primary scroll-m-20 text-4xl font-semibold tracking-tight first:mt-0',
        baseFontClass,
        className,
      )}
    >
      {children}
    </h3>
  );
};

export const TypographyH4 = ({ className, children }: React.ComponentProps<'h4'>) => {
  return (
    <h4
      className={cn(
        'text-primary scroll-m-20 text-3xl font-semibold tracking-tight first:mt-0',
        baseFontClass,
        className,
      )}
    >
      {children}
    </h4>
  );
};

export const TypographyH5 = ({ className, children }: React.ComponentProps<'h5'>) => {
  return (
    <h5
      className={cn(
        'text-primary scroll-m-20 text-2xl font-semibold tracking-tight first:mt-0',
        baseFontClass,
        className,
      )}
    >
      {children}
    </h5>
  );
};

export const TypographyH6 = ({ className, children }: React.ComponentProps<'h6'>) => {
  return (
    <h6
      className={cn(
        'text-primary scroll-m-20 text-xl font-semibold tracking-tight first:mt-0',
        baseFontClass,
        className,
      )}
    >
      {children}
    </h6>
  );
};

export const TypographyP = ({ className, children }: React.ComponentProps<'p'>) => {
  return (
    <p className={cn('text-primary scroll-m-20 leading-7 font-normal', baseFontClass, className)}>
      {children}
    </p>
  );
};

// App pages

export const TypographyHero = ({ className, children }: React.ComponentProps<'h1'>) => {
  return (
    <h1
      className={cn(
        'mb-4 scroll-m-20 text-4xl font-light tracking-tight md:text-6xl',
        baseFontClass,
        className,
      )}
    >
      {children}
    </h1>
  );
};

export const TypographyTitle = ({ className, children }: React.ComponentProps<'h2'>) => {
  return (
    <h2
      className={cn(
        'foreground mb-4 scroll-m-20 text-3xl font-light tracking-wide sm:mb-6 sm:text-4xl lg:text-5xl',
        baseFontClass,
        className,
      )}
    >
      {children}
    </h2>
  );
};

export const TypographySubtitle = ({ className, children }: React.ComponentProps<'div'>) => {
  return (
    <div
      className={cn(
        'muted-foreground scroll-m-20 text-lg leading-relaxed font-normal sm:text-xl',
        baseFontClass,
        className,
      )}
    >
      {children}
    </div>
  );
};

export const TypographySectionTitle = ({ className, children }: React.ComponentProps<'h3'>) => {
  return (
    <h3
      className={cn(
        'foreground scroll-m-20 text-xl font-semibold tracking-tight sm:text-2xl',
        baseFontClass,
        className,
      )}
    >
      {children}
    </h3>
  );
};

export const TypographySectionLabel = ({ className, children }: React.ComponentProps<'h4'>) => {
  return (
    <h4
      className={cn(
        'foreground scroll-m-20 text-lg font-semibold tracking-tight',
        baseFontClass,
        className,
      )}
    >
      {children}
    </h4>
  );
};

export const TypographyLabel = ({ className, children }: React.ComponentProps<'span'>) => {
  return <span className={cn('text-sm font-medium', baseFontClass, className)}>{children}</span>;
};

export const TypographyText = ({ className, children }: React.ComponentProps<'span'>) => {
  return (
    <span className={cn('muted-foreground text-base leading-relaxed', baseFontClass, className)}>
      {children}
    </span>
  );
};

export const TypographySmall = ({ className, children }: React.ComponentProps<'span'>) => {
  return (
    <span className={cn('muted-foreground text-sm', baseFontClass, className)}>{children}</span>
  );
};

export const TypographyLarge = ({ className, children }: React.ComponentProps<'span'>) => {
  return (
    <span className={cn('mb-4 text-lg leading-relaxed opacity-80', baseFontClass, className)}>
      {children}
    </span>
  );
};

export const TypographyStatus = ({ className, children }: React.ComponentProps<'span'>) => {
  return (
    <span className={cn('text-muted-foreground text-sm font-normal', baseFontClass, className)}>
      {children}
    </span>
  );
};
